var React = require('react');

function LinkedinIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M2.17516 3.38923C2.84379 3.38923 3.38582 2.84629 3.38582 2.17655C3.38582 1.50681 2.84379 0.963867 2.17516 0.963867C1.50654 0.963867 0.964508 1.50681 0.964508 2.17655C0.964508 2.84629 1.50654 3.38923 2.17516 3.38923Z","fill":"#337179","key":0}),React.createElement("path",{"d":"M4.52692 4.30739V11.0353H6.61237V7.70818C6.61237 6.83026 6.77724 5.98009 7.86397 5.98009C8.9357 5.98009 8.94898 6.98383 8.94898 7.76365V11.0359H11.0355V7.34631C11.0355 5.53392 10.646 4.14111 8.53127 4.14111C7.51592 4.14111 6.83534 4.69923 6.557 5.22742H6.52878V4.30739H4.52692ZM1.12845 4.30739H3.21722V11.0353H1.12845V4.30739Z","fill":"#337179","key":1})]);
}

LinkedinIcon.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = LinkedinIcon;

LinkedinIcon.default = LinkedinIcon;
